// Tremor Table [v0.0.3]

import React from "react"

import {cx} from "~/lib/utils";

const TableRoot = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, forwardedRef) => (
    <div
        ref={forwardedRef}
        // Activate if table is used in a float environment
        // className="flow-root"
    >
        <div
            // make table scrollable on mobile
            className={cx("w-full overflow-auto whitespace-nowrap", className)}
            {...props}
        >
            {children}
        </div>
    </div>
))

TableRoot.displayName = "TableRoot"

const Table = React.forwardRef<
    HTMLTableElement,
    React.TableHTMLAttributes<HTMLTableElement>
>(({ className, ...props }, forwardedRef) => (
    <table
        ref={forwardedRef}
        tremor-id="tremor-raw"
        className={cx(
            // base
            "w-full",
            className,
        )}
        {...props}
    />
))

Table.displayName = "Table"

const TableHead = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, forwardedRef) => (
    <thead ref={forwardedRef} className={cx(className)} {...props} />
))

TableHead.displayName = "TableHead"

const TableHeaderCell = React.forwardRef<
    HTMLTableCellElement,
    React.ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, forwardedRef) => (
    <th
        ref={forwardedRef}
        className={cx(
            // base
            "py-4 px-2 first:pl-4 last:pr-4 border-b text-left text-normal font-semibold",
            // text color
            "text-zinc-900",
            // border color
            "border-zinc-200",
            className,
        )}
        {...props}
    />
))

TableHeaderCell.displayName = "TableHeaderCell"

const TableBody = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, forwardedRef) => (
    <tbody
        ref={forwardedRef}
        className={cx(
            // base
            "divide-y",
            // divide color
            "divide-zinc-200",
            className,
        )}
        {...props}
    />
))

TableBody.displayName = "TableBody"

const TableRow = React.forwardRef<
    HTMLTableRowElement,
    React.HTMLAttributes<HTMLTableRowElement>
>(({ className, ...props }, forwardedRef) => (
    <tr
        ref={forwardedRef}
        className={cx(
            className,
        )}
        {...props}
    />
))

TableRow.displayName = "TableRow"

const TableCell = React.forwardRef<
    HTMLTableCellElement,
    React.TdHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, forwardedRef) => (
    <td
        ref={forwardedRef}
        className={cx(
            // base
            "py-4 px-2 first:pl-4 last:pr-4 text-normal",
            // text color
            "text-zinc-600",
            className,
        )}
        {...props}
    />
))

TableCell.displayName = "TableCell"

const TableFoot = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, forwardedRef) => {
    return (
        <tfoot
            ref={forwardedRef}
            className={cx(
                // base
                "border-t text-left font-semibold",
                // text color
                "text-zinc-900",
                // border color
                "border-zinc-200",
                className,
            )}
            {...props}
        />
    )
})

TableFoot.displayName = "TableFoot"

const TableCaption = React.forwardRef<
    HTMLTableCaptionElement,
    React.HTMLAttributes<HTMLTableCaptionElement>
>(({ className, ...props }, forwardedRef) => (
    <caption
        ref={forwardedRef}
        className={cx(
            // base
            "py-4 px-2 first:pl-4 last:pr-4 text-center text-normal",
            // text color
            "text-zinc-500",
            className,
        )}
        {...props}
    />
))

TableCaption.displayName = "TableCaption"

export {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableFoot,
    TableHead,
    TableHeaderCell,
    TableRoot,
    TableRow,
}
